import { Heading, Text } from 'ui-kit/typography'
import { UniversalIntegrations } from 'routes/components/Features/UniversalIntegrations'
import clsx from 'clsx'
import classes from './UniversalIntegrationsHero.module.scss'

export const UniversalIntegrationsHero = () => {
  return (
    <section className={classes.section}>
      <Heading as={'h1'} size={'xxl'} center balance className={classes.title}>
        Universal Integrations
      </Heading>
      <Text size={'lg'} center balance className={classes.subtitle}>
        The only practical way to build integrations with thousands of apps.
      </Text>
      <UniversalIntegrations className={classes.wrapper} />
      <Text
        size={'lg'}
        center
        balance
        className={clsx(classes.subtitle, classes.subtitle__bottom)}
      >
        Build each integration scenario only once. Scale it to all the relevant
        apps with the help of Al. Customize for individual apps and customers if
        needed
      </Text>
    </section>
  )
}
